import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {offerUrlBuilder} from "../../offer/helpers/friendly_offer_list/offer_url_builder";
import {ISurveyData} from "../../user/types/IBuildSurveyParams";

interface IListingRegion {
    id: number;
    slug: string;
    type: number;
}

export const getFavouritesEmptyListingUrl = (
    survey: Pick<ISurveyData, "price" | "regions" | "rooms" | "types"> | null | undefined,
    regions: IListingRegion[] = []
): string => {
    const rooms_0 = typeof survey?.rooms?.lower === "number" ? survey.rooms.lower : undefined;
    const rooms_1 = typeof survey?.rooms?.upper === "number" ? survey.rooms.upper : undefined;
    const price_1 = typeof survey?.price?.upper === "number" && survey.price.upper > 0 ? survey.price.upper : undefined;
    const type = survey?.types?.length === 1 ? survey.types[0] : undefined;
    const listingQuery = {
        ...(rooms_0 != null ? {rooms_0} : {}),
        ...(rooms_1 != null ? {rooms_1} : {}),
        ...(price_1 != null ? {price_1} : {}),
        ...(type != null ? {type} : {})
    };

    if (regions.length > 1) {
        return appendQueryString(rpAppLink.offer.multiList(), {
            ...listingQuery,
            region: regions.map((region) => region.id)
        });
    }

    const region = regions[0];

    return rpAppLink.offer.listFriendly({
        friendlySlug: offerUrlBuilder({
            ...listingQuery,
            ...(region ? {region: region.slug} : {})
        }).friendlySlug
    });
};
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {offerUrlBuilder} from "../../offer/helpers/friendly_offer_list/offer_url_builder";
import {ISurveyData} from "../../user/types/IBuildSurveyParams";

interface IListingRegion {
    id: number;
    slug: string;
    type: number;
}

export const getFavouritesEmptyListingUrl = (
    survey: Pick<ISurveyData, "price" | "regions" | "rooms" | "types"> | null | undefined,
    regions: IListingRegion[] = []
): string => {
    const rooms_0 = typeof survey?.rooms?.lower === "number" ? survey.rooms.lower : undefined;
    const rooms_1 = typeof survey?.rooms?.upper === "number" ? survey.rooms.upper : undefined;
    const price_1 = typeof survey?.price?.upper === "number" && survey.price.upper > 0 ? survey.price.upper : undefined;
    const type = survey?.types?.length === 1 ? survey.types[0] : undefined;
    const listingQuery = {
        ...(rooms_0 != null ? {rooms_0} : {}),
        ...(rooms_1 != null ? {rooms_1} : {}),
        ...(price_1 != null ? {price_1} : {}),
        ...(type != null ? {type} : {})
    };

    if (regions.length > 1) {
        return appendQueryString(rpAppLink.offer.multiList(), {
            ...listingQuery,
            region: regions.map((region) => region.id)
        });
    }

    const region = regions[0];

    return rpAppLink.offer.listFriendly({
        friendlySlug: offerUrlBuilder({
            ...listingQuery,
            ...(region ? {region: region.slug} : {})
        }).friendlySlug
    });
};
